export default __webpack_public_path__ + "static/media/insta.932ebe26.jpg";